import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import ToastMessage from "../../utils/mui/righttoptoast";
import api from "../../api/api";
import { Backdrop, CircularProgress } from "@mui/material";
import { getPracticeId, patientPhotoUrl } from "../../config/practice";

const AbdominalDopplerModal = ({ ismodal, setIsmodal, data }) => {
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("error");
  const [providerList, setProviderList] = useState([]);
  const [showAscitesComment, setShowAscitesComment] = useState(false);
  const [showVaricesComment, setShowVaricesComment] = useState(false);
  const [showHepatopedalComment, setShowHepatopedalComment] = useState(false);
  const [showHepatofugalComment, setShowHepatofugalComment] = useState(false);
  const practiseid = getPracticeId();
  const[isLoading,setIsLoading]=useState(false)
  const formattedDOB = dayjs(data?.dob).format("DD-MM-YYYY");
  const calculateAge = (dob) => dayjs().diff(dayjs(dob), "year");
  const age = calculateAge(data?.dob);

  const [formData, setFormData] = useState({
    provider: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    history: "",
    impression: "",
    signature: "",
    liverComment: "",
    mainPortalVeinComment: "",
    hepaticVeinsComment: "",
    hepaticVeinsRt: "",
    hepaticVeinsMid: "",
    hepaticVeinsLt: "",
    hepaticArtery: "",
    spleen: "",
    splenicVein: "",
    ascites: "",
    ascitesComment: "",
    varices: "",
    varicesComment: "",
    hepatopedal: "",
    hepatopedalComment: "",
    hepatofugal: "",
    hepatofugalComment: "",
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    if (ismodal) getProviders();
  }, [ismodal]);

useEffect(() => {
  console.log("useEffect triggered: providerList =", providerList, "data =", data, "formData.provider =", formData.provider);

  if (!formData.provider && providerList.length > 0) {
    const providerNames = providerList.map(x => x.providername);
    console.log("All provider names:", providerNames);

    if (data?.linked_provider && providerNames.includes(data.linked_provider)) {
      console.log("Setting provider from linked_provider:", data.linked_provider);
      handleChange("provider", data.linked_provider);
    } else {
      console.log("Setting provider from first provider in list:", providerList[0].providername);
      handleChange("provider", providerList[0].providername);
    }
  }
}, [providerList, data, formData.provider]);


  const getProviders = async () => {
    try {
      const response = await api.get(`/v1/${practiseid}/providers`);
      if (response.status === 200 && Array.isArray(response.data)) {
        setProviderList(response.data);
      }
    } catch (error) {
      console.error("Error fetching providers:", error);
      setToastMessage("Failed to load providers");
      setToastSeverity("error");
      setOpenToast(true);
    }
  };

  const validateForm = () => {
    const errors = [];
    if (!formData.provider) errors.push("Provider is required.");
    if (!formData.examDate) errors.push("Exam Date is required.");
    if (!formData.history.trim()) errors.push("Patient History is required.");
    if (!formData.impression.trim()) errors.push("Impression is required.");
    if (!formData.signature.trim()) errors.push("Signature is required.");
    if (!formData.hepaticVeinsRt.trim()) errors.push("Hepatic Veins Rt is required.");
    if (!formData.hepaticVeinsMid.trim()) errors.push("Hepatic Veins Mid is required.");
    if (!formData.hepaticVeinsLt.trim()) errors.push("Hepatic Veins Lt is required.");
    if (!formData.hepaticArtery.trim()) errors.push("Hepatic Artery is required.");
    if (!formData.spleen.trim()) errors.push("Spleen is required.");
    if (!formData.splenicVein.trim()) errors.push("Splenic Vein is required.");
    if (!formData.ascites) errors.push("Ascites selection is required.");
   
    if (!formData.varices) errors.push("Varices selection is required.");

    if (!formData.hepatopedal) errors.push("Hepatopedal Flow selection is required.");

    if (!formData.hepatofugal) errors.push("Hepatofugal Flow selection is required.");

    return errors;
  };

  const handleSave = async() => {
    const errors = validateForm();
    if (errors.length > 0) {
      setToastMessage(errors[0]);
      setToastSeverity("error");
      setOpenToast(true);
    } else {      
try {
     setIsLoading(true)
      const selectedProvider = providerList.find(
  (p) => p.providername === formData.provider
);

const patientDetails = {
        patientid: data.patientid,
        appointmentid: data.appointmentid,
        firstname: data.firstname,
        lastname: data.lastname,
             providername: formData.provider,
          providerid:  selectedProvider?.providerid,
            pat_dob: data?.dob,
         pat_name: `${data?.firstname} ${data?.lastname}`,
        dob: formattedDOB,
        age,
        gender: data.gender === "M" ? "Male" : "Female",
      };

      const combinedData = {
        ...patientDetails,
        ...formData,
      };
        const user=await api.get('/auth/me')
          const [year, month, day] = formData.examDate.split("-");
          const formattedDate = `${month}/${day}/${year}`;
      
      const response = await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/insert-db`, {
        "Worksheet_Type": "ABDOMINAL_ULTRASOUND_DOPPLER",
        "createdby": user?.username || '',
        "appurl": window.location.origin,
          // "appurl": "https://api.prd.brainymed.com",
        "Exam_Date": formattedDate,
        "data":combinedData
      });
      
      if(response.status==200){
        const pdf=await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/generate-pdf`,{
        "filename": response?.data?.filename,
            // "appurl": "https://api.prd.brainymed.com",
        "worksheet_type": "ABDOMINAL_ULTRASOUND_DOPPLER",
       "appurl": window.location.origin,
        "exam_date": formattedDate
        })
        setToastMessage("Form Submitted Successfully");
          setToastSeverity("success");
          setOpenToast(true);
       setTimeout(() => {
    
        setIsmodal(false);
      }, 1000);
      
      }else{
        setToastMessage(response.message);
          setToastSeverity("info");
          setOpenToast(true);
      }
} catch (error) {
  console.log(error)
}finally{
setIsLoading(false)

}
     
    }
  };

  const resetForm = () => {
    setFormData({
      provider: "",
      examDate: dayjs().format("YYYY-MM-DD"),
      history: "",
      impression: "",
      signature: "",
      liverComment: "",
      mainPortalVeinComment: "",
      hepaticVeinsComment: "",
      hepaticVeinsRt: "",
      hepaticVeinsMid: "",
      hepaticVeinsLt: "",
      hepaticArtery: "",
      spleen: "",
      splenicVein: "",
      ascites: "",
      ascitesComment: "",
      varices: "",
      varicesComment: "",
      hepatopedal: "",
      hepatopedalComment: "",
      hepatofugal: "",
      hepatofugalComment: "",
    });
    setShowAscitesComment(false);
    setShowVaricesComment(false);
    setShowHepatopedalComment(false);
    setShowHepatofugalComment(false);
  };

  if (!ismodal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50 overflow-y-auto min-h-screen px-2 py-6">
      <div className="w-full max-w-4xl text-start bg-white rounded-lg p-6 shadow-xl relative">
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-semibold">ABDOMINAL ULTRASOUND DOPPLER</h2>
          <button onClick={() => setIsmodal(false)} className="text-xl font-bold text-gray-500 hover:text-black">×</button>
        </div>
        <hr className="mb-4 border-gray-300" />

        <div className="flex items-center space-x-4 mb-4">
          <img
            src={patientPhotoUrl(data.patientid)}
            alt="User"
            className="w-16 h-full max-h-28 rounded-md object-cover"
          />
          <div className="space-y-1">
            <div className="text-white bg-violet-500 rounded-lg px-1.5 py-0.5 text-xs font-medium inline-block">
       #{data?.patientid}
            </div>
            <div className="text-base font-semibold">{data?.firstname + " " + data?.lastname}</div>
            <div className="text-sm text-gray-700"><span className="font-semibold">Date of Birth:</span> {formattedDOB}</div>
            <div className="text-sm text-gray-700"><span className="font-semibold">Age:</span> {age}  | <span className="font-semibold">Gender:</span> {data?.gender === "M" ? "Male" : "Female"}</div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Providers</label>
            <select
              className="w-full border rounded px-2 py-1"
              value={formData.provider}
              onChange={(e) => handleChange("provider", e.target.value)}
            >
              <option value="">Select Provider</option>
              {providerList.map((provider) => (
                <option key={provider.id} value={provider.providername}>
                  {provider.providername}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Exam Date</label>
            <input
              type="date"
              className="w-full border rounded px-2 py-1"
              value={formData.examDate}
              onChange={(e) => handleChange("examDate", e.target.value)}
            />
          </div>
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Patient History</label>
          <textarea
            placeholder="Enter Patient History here..."
            className="w-full border rounded px-2 py-1 mt-1"
            rows={3}
            value={formData.history}
            onChange={(e) => handleChange("history", e.target.value)}
          />
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Liver</label>
          <textarea
            placeholder="Enter Comments here..."
            className="w-full border rounded px-2 py-1 mt-1"
            rows={2}
            value={formData.liverComment}
            onChange={(e) => handleChange("liverComment", e.target.value)}
          />
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Main Portal Vein</label>
          <textarea
            placeholder="Enter Comments here..."
            className="w-full border rounded px-2 py-1 mt-1"
            rows={2}
            value={formData.mainPortalVeinComment}
            onChange={(e) => handleChange("mainPortalVeinComment", e.target.value)}
          />
        </div>

        <div className="grid grid-cols-3 gap-4 mt-4">
          <div>
            <label className="text-sm font-medium block mb-1">Rt</label>
            <input
              className="border rounded px-2 py-1 w-full"
              placeholder="Rt"
              value={formData.hepaticVeinsRt}
              onChange={(e) => handleChange("hepaticVeinsRt", e.target.value)}
            />
          </div>
          <div>
            <label className="text-sm font-medium block mb-1">Mid</label>
            <input
              className="border rounded px-2 py-1 w-full"
              placeholder="MID"
              value={formData.hepaticVeinsMid}
              onChange={(e) => handleChange("hepaticVeinsMid", e.target.value)}
            />
          </div>
          <div>
            <label className="text-sm font-medium block mb-1">Lt</label>
            <input
              className="border rounded px-2 py-1 w-full"
              placeholder="Lt"
              value={formData.hepaticVeinsLt}
              onChange={(e) => handleChange("hepaticVeinsLt", e.target.value)}
            />
          </div>
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Hepatic Veins</label>
          <textarea
            placeholder="Enter Comments here..."
            className="w-full border rounded px-2 py-1 mt-1"
            rows={2}
            value={formData.hepaticVeinsComment}
            onChange={(e) => handleChange("hepaticVeinsComment", e.target.value)}
          />
        </div>

        <div className="grid grid-cols-1 gap-4 mt-4">
          <div>
            <label className="text-sm font-medium block mb-1">Hepatic Artery</label>
            <input
              className="border rounded px-2 py-1 w-full"
              placeholder="Hepatic Artery"
              value={formData.hepaticArtery}
              onChange={(e) => handleChange("hepaticArtery", e.target.value)}
            />
          </div>
          <div>
            <label className="text-sm font-medium block mb-1">Spleen</label>
            <input
              className="border rounded px-2 py-1 w-full"
              placeholder="Spleen"
              value={formData.spleen}
              onChange={(e) => handleChange("spleen", e.target.value)}
            />
          </div>
          <div>
            <label className="text-sm font-medium block mb-1">Splenic Vein</label>
            <input
              className="border rounded px-2 py-1 w-full"
              placeholder="Splenic Vein"
              value={formData.splenicVein}
              onChange={(e) => handleChange("splenicVein", e.target.value)}
            />
          </div>
        </div>

        <div className="mt-4 grid grid-cols-1 gap-4">
          {/* ASCITES */}
          <div>
            <div className="grid grid-cols-3 items-center gap-2">
              <label className="text-sm font-medium uppercase">Ascites</label>
              <div className="flex gap-4">
                <label>
                  <input
                    type="radio"
                    name="ascites"
                    value="Yes"
                    checked={formData.ascites === "Yes"}
                    onChange={(e) => handleChange("ascites", e.target.value)}
                  /> Yes
                </label>
                <label>
                  <input
                    type="radio"
                    name="ascites"
                    value="No"
                    checked={formData.ascites === "No"}
                    onChange={(e) => handleChange("ascites", e.target.value)}
                  /> No
                </label>
              </div>
              <div className="flex justify-end">
                <FaPlus
                  className="cursor-pointer bg-gray-200 rounded-full p-1"
                  onClick={() => setShowAscitesComment(!showAscitesComment)}
                />
              </div>
            </div>
            {showAscitesComment && (
              <textarea
                className="w-full border rounded px-2 py-1 mt-2"
                rows={2}
                placeholder="Ascites Comments..."
                value={formData.ascitesComment}
                onChange={(e) => handleChange("ascitesComment", e.target.value)}
              />
            )}
          </div>

          {/* VARICES */}
          <div>
            <div className="grid grid-cols-3 items-center gap-2">
              <label className="text-sm font-medium uppercase">Varices</label>
              <div className="flex gap-4">
                <label>
                  <input
                    type="radio"
                    name="varices"
                    value="Yes"
                    checked={formData.varices === "Yes"}
                    onChange={(e) => handleChange("varices", e.target.value)}
                  /> Yes
                </label>
                <label>
                  <input
                    type="radio"
                    name="varices"
                    value="No"
                    checked={formData.varices === "No"}
                    onChange={(e) => handleChange("varices", e.target.value)}
                  /> No
                </label>
              </div>
              <div className="flex justify-end">
                <FaPlus
                  className="cursor-pointer bg-gray-200 rounded-full p-1"
                  onClick={() => setShowVaricesComment(!showVaricesComment)}
                />
              </div>
            </div>
            {showVaricesComment && (
              <textarea
                className="w-full border rounded px-2 py-1 mt-2"
                rows={2}
                placeholder="Varices Comments..."
                value={formData.varicesComment}
                onChange={(e) => handleChange("varicesComment", e.target.value)}
              />
            )}
          </div>

          {/* HEPATOPEDAL FLOW */}
          <div>
            <div className="grid grid-cols-3 items-center gap-2">
              <label className="text-sm font-medium uppercase">Hepatopedal Flow</label>
              <div className="flex gap-4">
                <label>
                  <input
                    type="radio"
                    name="hepatopedal"
                    value="Yes"
                    checked={formData.hepatopedal === "Yes"}
                    onChange={(e) => handleChange("hepatopedal", e.target.value)}
                  /> Yes
                </label>
                <label>
                  <input
                    type="radio"
                    name="hepatopedal"
                    value="No"
                    checked={formData.hepatopedal === "No"}
                    onChange={(e) => handleChange("hepatopedal", e.target.value)}
                  /> No
                </label>
              </div>
              <div className="flex justify-end">
                <FaPlus
                  className="cursor-pointer bg-gray-200 rounded-full p-1"
                  onClick={() => setShowHepatopedalComment(!showHepatopedalComment)}
                />
              </div>
            </div>
            {showHepatopedalComment && (
              <textarea
                className="w-full border rounded px-2 py-1 mt-2"
                rows={2}
                placeholder="Hepatopedal Flow Comments..."
                value={formData.hepatopedalComment}
                onChange={(e) => handleChange("hepatopedalComment", e.target.value)}
              />
            )}
          </div>

          {/* HEPATOFUGAL FLOW */}
          <div>
            <div className="grid grid-cols-3 items-center gap-2">
              <label className="text-sm font-medium uppercase">Hepatofugal Flow</label>
              <div className="flex gap-4">
                <label>
                  <input
                    type="radio"
                    name="hepatofugal"
                    value="Yes"
                    checked={formData.hepatofugal === "Yes"}
                    onChange={(e) => handleChange("hepatofugal", e.target.value)}
                  /> Yes
                </label>
                <label>
                  <input
                    type="radio"
                    name="hepatofugal"
                    value="No"
                    checked={formData.hepatofugal === "No"}
                    onChange={(e) => handleChange("hepatofugal", e.target.value)}
                  /> No
                </label>
              </div>
              <div className="flex justify-end">
                <FaPlus
                  className="cursor-pointer bg-gray-200 rounded-full p-1"
                  onClick={() => setShowHepatofugalComment(!showHepatofugalComment)}
                />
              </div>
            </div>
            {showHepatofugalComment && (
              <textarea
                className="w-full border rounded px-2 py-1 mt-2"
                rows={2}
                placeholder="Hepatofugal Flow Comments..."
                value={formData.hepatofugalComment}
                onChange={(e) => handleChange("hepatofugalComment", e.target.value)}
              />
            )}
          </div>
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Sonographer's Impression Not Official Report</label>
          <textarea
            placeholder="Enter Sonographer's Impression here..."
            className="w-full border rounded px-2 py-1 mt-1"
            rows={3}
            value={formData.impression}
            onChange={(e) => handleChange("impression", e.target.value)}
          />
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Signature</label>
          <input
            className="w-full border rounded px-2 py-1 mt-1"
            placeholder="Signature"
            value={formData.signature}
            onChange={(e) => handleChange("signature", e.target.value)}
          />
        </div>

        <div className="flex justify-end mt-6">
          <button onClick={handleSave} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">Save</button>
        </div>
      </div>
<Backdrop
  sx={{
    color: '#fff',
    zIndex: (theme) => theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity (default is 0.5)
  }}
  open={isLoading}
>
  <CircularProgress color="inherit" />
  </Backdrop>
      <ToastMessage message={toastMessage} severity={toastSeverity} open={openToast} handleClose={() => setOpenToast(false)} />
    </div>
  );
};

export default AbdominalDopplerModal;